// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"application"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12.0001 2L20.6604 7V17L12.0001 22L3.33984 17V7L12.0001 2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12.0001 2L20.6604 7V17L12.0001 22L3.33984 17V7L12.0001 2Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9 10L12 12M12 12L15 10M12 12V15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-application')
export default class ApplicationIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'application',
    }
  }
}
